// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DatapointFilterValuesValuesFromJSON(json) {
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'parentCode': !exists(json, 'parentCode') ? undefined : json['parentCode'],
    };
}
export function DatapointFilterValuesValuesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'code': value.code,
        'label': value.label,
        'parentCode': value.parentCode,
    };
}
